import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

// Google Tag Manager
export const googleTagManagerHTMLScript = (tracker: ConversionTracker) => {
  return `
	<script>window.dataLayer = window.dataLayer || [];window.dataLayer.push(${JSON.stringify(
    tracker.data_layer,
  )});</script><script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${
    tracker.tracking_pixel
  }');</script><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${
    tracker.tracking_pixel
  }" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
};
